import { SwitchComponent } from "primitives/Switch/Switch";
import { ReferenceContext } from "providers/ReferenceProvider";
import { ThemeContext } from "providers/ThemeProvider";
import { FunctionComponent, useContext } from "react";
import NavButton from "./NavButton/NavButton";
import styles from "./stickyMenu.module.scss";

const Navbar: FunctionComponent<{
  className?: string;
  isHomePage?: boolean;
}> = ({ className, isHomePage = false }) => {
  const { hasTheme } = useContext(ThemeContext);
  return (
    <ReferenceContext.Consumer>
      {(refs) => (
        <div
          className={`${styles.navButtonsWrapper} ${className}`}
          aria-controls="nav-bar"
        >
          {isHomePage ? null : (
            <NavButton
              className={styles.homeNavButton}
              title={"Home"}
              currRef={refs.homeRef}
            />
          )}
          <NavButton title={"About"} currRef={refs.aboutRef} />
          <NavButton title={"Experience"} currRef={refs.experienceRef} />
          <NavButton title={"Project"} currRef={refs.projectRef} />
          <NavButton title={"Contact"} currRef={refs.contactRef} />
          <div className={styles.switchWrapper}>
            {isHomePage && (
              <div className={styles.titleWrapper}>
                <p className={styles.mode}>{"<mode>"}</p>
                <p className={styles.modeText}>{hasTheme.toUpperCase()}</p>
                <p className={styles.mode}>{"</mode>"}</p>
              </div>
            )}
            <SwitchComponent />
          </div>
        </div>
      )}
    </ReferenceContext.Consumer>
  );
};

export default Navbar;
